import { render, staticRenderFns } from "./search-box-serial.vue?vue&type=template&id=60ad6d52"
import script from "./search-box-serial.vue?vue&type=script&lang=js"
export * from "./search-box-serial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports